import PropTypes from 'prop-types';
import Anchor from 'sd-ui/dist/commonjs/components/Anchor/Anchor';

export default function ArticleActionAnchor({
  href, icon, label, onClick,
}) {
  return (
    <Anchor
      icon={icon}
      className="text-xs u-margin-l-right call-to-action"
      href={href}
      iconPlacement="left"
      target="_blank"
      onClick={onClick}
    >
      {label}
    </Anchor>
  );
}

ArticleActionAnchor.propTypes = {
  href: PropTypes.string.isRequired,
  icon: PropTypes.element.isRequired,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
};

ArticleActionAnchor.defaultProps = {
  onClick: undefined,
};
